import { FormProvider } from 'react-hook-form';

import { IconButton, SlideOut, SlideOutControls } from '@hsp/react-component-library';

import { useAddConfiguration } from '@p/security/users/dashboard/component/slideout/add-user/hooks/configuration.hook';
import { useAddUserCreateForm } from '@p/security/users/dashboard/component/slideout/add-user/hooks/form/create.form';
import AddUserBody from '@p/security/users/dashboard/component/slideout/add-user/slideout-body/body.component';

import { s } from '@u/strings';

const AddUserSlideOut = () => {
  const methods = useAddUserCreateForm();
  const { addUser, setAddUser, handleSubmitted } = useAddConfiguration();
  const { handleSubmit } = methods;

  return (
    <>
      <FormProvider {...methods}>
        <SlideOut
          isOpen={addUser}
          onClosed={() => {
            setAddUser(false);
            methods.reset();
          }}
          title="New User">
          <form
            id="frm-addUser-userDashboard"
            onSubmit={handleSubmit((formData) => handleSubmitted(formData))}>
            <AddUserBody />
          </form>
          <SlideOutControls>
            <IconButton
              color="primary"
              form="frm-addUser-userDashboard"
              icon={'save'}
              type="submit">
              {s('Site.Add')}
            </IconButton>
            <IconButton
              className="ms-2"
              color="primary"
              form="frm-addUser-userDashboard"
              icon={'close'}
              type="submit">
              {s('Site.Cancel')}
            </IconButton>
          </SlideOutControls>
        </SlideOut>
      </FormProvider>
    </>
  );
};

export default AddUserSlideOut;
